let baseUrl = '';//基础路径
let pdfUrl = '';//文件路径
let wsUrl = '';//全双工通信路径
const env = process.env.NODE_ENV;

//生成环境
if (process.env.VUE_APP_PROFILE) {
	switch (process.env.VUE_APP_PROFILE) {
		case 'test':
			baseUrl = 'https://adminapi.boxpopp.com/admin/'
			break;
		case 'prod':
			baseUrl = 'https://api.boxpopp.com/admin/'
			break;
	}
} else {
	// 开发环境
	baseUrl = 'https://adminapi.boxpopp.com/admin/';
}

export {
	baseUrl,
	pdfUrl,
	wsUrl
};
